/* eslint-disable no-use-before-define */
import React from 'react'
import kebabCase from 'lodash/kebabCase'
import StoreGridItem from './StoreGridItem'
import styles from './styles.module.scss'

const DesktopStores = ({ stores, storeToShow, setStoreToShow }) => {
  return (
    <div className={styles.stores}>
      <h1 className={styles.stores__header}>Stores</h1>
      <h2 className={styles.stores__subheader}>
        Find one of our {stores?.length || '10'} stores nearest you.
      </h2>

      <div className={styles['stores__store-container']}>
        {stores?.length > 0 &&
          stores.map((s, i) => (
            <StoreGridItem
              key={kebabCase(s.displayName)}
              index={i}
              store={s}
              permalink={kebabCase(s.displayName)}
              storeToShow={storeToShow}
              setStoreToShow={setStoreToShow}
            />
          ))}
      </div>
    </div>
  )
}

export default DesktopStores
